import styled from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";

export const Card = styled.div<SpaceProps>`
    display: block;
    position: relative;
    width: 100%;
    margin-top: ${theme.space[3]}px;
    margin-bottom: ${theme.space[5]}px;
    padding: ${theme.space[2]}px;
    border: 1px solid ${theme.colors.grey2};
    transition: color 0.24s;
    ${space}
    @media ${getBreakpoint("up", "md")} {
        margin-bottom: ${theme.space[3] * 2}px;
    }
`;

export const CardTitle = styled.div`
    font-family: ${theme.fonts.regular};
`;

export const License = styled.div`
    margin-top: ${theme.space[1]}px;
`;

export const LicenseLabel = styled.span`
    display: inline-block;
    margin-right: 5px;
    color: ${theme.colors.grey4};
`;

export const RadioGroup = styled.fieldset`
    margin: ${theme.space[5]}px 0;
`;

export const RadioGroupTitle = styled.legend`
    margin-bottom: ${theme.space[1]}px;
`;

export const CheckboxGroup = styled.fieldset`
    margin: ${theme.space[5]}px 0;
`;

export const CheckboxGroupTitle = styled.legend`
    margin-bottom: ${theme.space[1]}px;
`;
